<template>
  <v-dialog
    v-model="activo"
    max-width="1000"
  >
    <v-card
      flat
      max-width="1000px"
    >
      <v-card-title>
        Selección de Detalles
        <v-spacer></v-spacer>
        <v-btn icon @click="activo = false" title="Cerrar"><v-icon>fas fa-times</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <!-- Tabla de Artículos y Conceptos -->
        <v-row :no-gutters="$vuetify.breakpoint.xs">
          <v-col cols="12" class="pt-0">
            <v-data-table
              class="cebra elevation-2 mt-2"
              :headers="headers"
              :items="tipoIngreso == 1 ? articulos : conceptos"
              :loading="load"
              dense
              :search="search"
            >
              <!-- Buscador en el datatable -->
              <template v-slot:top>
                <v-row class="d-flex justify-space-between" no-gutters>
                  <v-col cols="6" sm="2">
                    <v-autocomplete
                      v-model="tipoIngreso"
                      item-text="tipo_nombre"
                      item-value="tipo_id"
                      :items="tipo_ingresos"
                      hide-details
                      outlined
                      dense
                      label="Tipo Ingreso"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <SearchDataTable
                      v-model="search"
                    />
                  </v-col>
                </v-row>
              </template>
              <!-- Items -->
              <template v-slot:[`item.precio_s_iva`]="{ item }">
                <v-row class="d-flex justify-center" no-gutters>
                  <v-text-field v-model="item.precio_s_iva" prefix="$" type="number" @keypress.enter="addItem(item)" outlined dense hide-details></v-text-field>
                </v-row>
              </template>
              <!-- Acciones -->
              <template v-slot:[`item.acciones`]="{ item }">
                <v-btn icon small @click="addItem(item)"><v-icon small color="success" title="Agregar">fas fa-check</v-icon></v-btn>
              </template>
              <template v-slot:no-data>
                <v-alert
                  class="mx-auto mt-4"
                  max-width="400"
                  type="warning"
                  border="left"
                  dense
                  text
                >
                  No hay datos para los filtros seleccionados
                </v-alert>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-end pb-4">
        <v-btn color="warning" @click="visible = false">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SearchDataTable from '../util/SearchDataTable.vue'
import { format_money } from '../../util/utils'
export default {
  props: {
    datos: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed: {
    activo: {
      get(){
        return this.datos.activo
      },
      set(value){
        this.$emit('setearModalArtConc', value)
      }
    },
    articulos: {
      get(){
        return this.datos.articulos
      }
    },
    conceptos: {
      get(){
        return this.datos.conceptos
      }
    },
    tipo_ingresos: {
      get(){
        return this.datos.tipo_ingresos
      }
    }
  },
  components: {
    SearchDataTable,
  },
  data() {
    return {
      headers: [
        { text: 'Código', align: 'center', value: 'codigo' },
        { text: 'Descripcion', align: 'center', value: 'nombre' },
        { text: 'Cantidad', align: 'center', value: 'cantidad' },
        { text: 'Precio S/Iva', align: 'center', value: 'precio_s_iva' },
        { text: 'Seleccionar', align: 'center', value: 'acciones' }
      ],
      load: false,
      search: '',
      tipoIngreso: 1
    }
  },
  created () {

  },
  methods: {
    addItem(item){
      this.$emit('setItem', item)
    }
  },
  watch: {
    
  },
}
</script>

<style>

</style>